import { ofType } from 'redux-observable';
import { from, iif, of } from 'rxjs';
import { catchError, debounceTime, mergeMap } from 'rxjs/operators';

import { notify } from 'common/hooks/useNotification';
import { CommonEpic } from 'common/types';

import { actionLoadingGetWallets } from 'views/wallet-new/redux/actions';

import actionTypes from './earn.actionTypes';
import * as actions from './earn.actions';
import { actionGetEarnHistory, actionGetEarnSubscriptions } from './earn.actions';
import * as earnApi from './earn.api';

export const epicGeEarnProducts: CommonEpic<typeof earnApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(actionTypes.LOADING_GET_EARN_PRODUCTS),
    debounceTime(1000),
    mergeMap(() =>
      from(api.getEarnProducts()).pipe(
        mergeMap((response) =>
          iif(
            () => _state$.value.common.user.isAuthenticated === true,
            of(actions.actionSuccessGetEarnProducts(response), actions.actionGetEarnSubscriptions()),
            of(actions.actionSuccessGetEarnProducts(response)),
          ),
        ),
        catchError((error) => of(actions.actionErrorGetEarnProducts(error))),
      ),
    ),
  );

export const epicGeEarnSubscriptions: CommonEpic<typeof earnApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(actionTypes.LOADING_GET_EARN_SUBSCRIPTIONS),
    // debounceTime(1000),
    mergeMap(() =>
      from(api.getEarnSubscriptions()).pipe(
        mergeMap((response) => of(actions.actionSuccessGetEarnSubscriptions(response))),
        catchError((error) => of(actions.actionErrorGetEarnSubscriptions(error))),
      ),
    ),
  );

export const epicGeEarnHistory: CommonEpic<typeof earnApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(actionTypes.LOADING_GET_EARN_HISTORY),
    mergeMap(() =>
      from(api.getEarnHistory()).pipe(
        mergeMap((response) => of(actions.actionSuccessGetEarnHistory(response))),
        catchError((error) => of(actions.actionErrorGetEarnHistory(error))),
      ),
    ),
  );

export const epicGeEarnSubscriptionTransactions: CommonEpic<typeof earnApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(actionTypes.LOADING_GET_EARN_SUBSCRIPTION_TRANSACTIONS),
    mergeMap((action) =>
      from(api.getEarnSubscriptionTransactions(action.payload)).pipe(
        mergeMap((response) => of(actions.actionSuccessGetEarnSubscriptionTransactions(response))),
        catchError((error) => of(actions.actionErrorGetEarnSubscriptionTransactions(error))),
      ),
    ),
  );

export const createEarnNotification: CommonEpic<typeof earnApi> = (action$) =>
  action$.pipe(
    ofType(actionTypes.SIGNALR_CREATE_EARN),
    mergeMap(({ payload }) => {
      const isSuccessful = payload.status === 'Completed';

      notify({
        autoClose: isSuccessful ? undefined : false,
        titleFn: (translate) =>
          translate(
            isSuccessful
              ? 'mobile:earn:startEarning:notification:success'
              : 'mobile:earn:startEarning:notification:fail',
          )
            .replace('{AMOUNT}', payload?.amount.toString())
            .replace('{CURRENCY}', payload.currency),
      });

      return of(actionGetEarnSubscriptions(), actionGetEarnHistory());
    }),
  );

export const redemptionNotification: CommonEpic<typeof earnApi> = (action$) =>
  action$.pipe(
    ofType(actionTypes.SIGNALR_REDEMPTION_EARN),
    mergeMap(({ payload }) => {
      const isSuccessful = payload.status === 'Completed';

      notify({
        toastId: isSuccessful ? 'earn-redeem-notification-success' : 'earn-redeem-notification-fail',
        autoClose: isSuccessful ? undefined : false,
        titleFn: (translate) =>
          translate(
            isSuccessful ? 'mobile:earn:redeemEarning:message:success' : 'mobile:earn:redeemEarning:message:fail',
          )
            .replace('{AMOUNT}', payload?.amount.toString())
            .replace('{SYMBOL}', payload.currency),
      });

      return of(actionGetEarnSubscriptions(), actionLoadingGetWallets());
    }),
  );
